import { CoursesEffects } from "./courses.effect";
import { StudentMetricsEffects } from "./student-metrics.effect";
import { CourseMetricsEffects } from "./course-metrics.effect";
import { AssignmentsEffects } from "./assignments.effect";
import { StudentAssetsEffects } from "./student-assets.effect";
import { StudentActiveSubjectsEffects } from "#student/student-shared/store/effects/student-active-subjects.effects";
import { StudentActiveEditionsEffects } from "#student/student-shared/store/effects/student-active-editions.effects";

// so we can just have one import in teacher-classes.module
export const effects: any[] = [
    CoursesEffects,
    StudentMetricsEffects,
    CourseMetricsEffects,
    AssignmentsEffects,
    StudentAssetsEffects,
    StudentActiveSubjectsEffects,
    StudentActiveEditionsEffects,
];

export * from "./courses.effect";
export * from "./student-metrics.effect";
export * from "./course-metrics.effect";
export * from "./assignments.effect";
export * from "./student-assets.effect";
export * from "./student-active-subjects.effects";
export * from "./student-active-editions.effects";
